// ─────────────────────────────────────────────────────────────
// 全域錯誤上報出口（友盟 CNZZ 自定義事件）
//
// 全站 error boundary（app/*error.tsx、ErrorBoundary）皆走此出口，
// 上報邏輯集中於此，無需逐處改動。
//
// 【對齊 member-pc】舊專案以 CNZZ（window._czc）做統計，事件上報走
//   _czc.push(['_trackEvent', category, action, label, value])。本檔
//   沿用同一介面，把前端運行時例外當作一個統計事件上報。
//   ・category = 'fe_error'
//   ・action   = context（哪個 error boundary / 區塊）
//   ・label    = 錯誤訊息（截斷）
//   SDK 由 lib/umeng.ts 載入；未就緒時靜默跳過，不影響頁面。
//
// 【侷限】CNZZ 為統計平臺，不做 source map 反解，label 為壓縮環境下
//   的 error.message；多數情況 context + message 已足夠定位。
// ─────────────────────────────────────────────────────────────

const ERROR_EVENT_CATEGORY = 'fe_error';

export function reportError(error: unknown, context?: string): void {
  // String(error) 對「toString 本身拋錯」的值（如 Proxy、Object.create(null)）
  //   會再拋一次。本函數的呼叫點正是 componentDidCatch / global-error 與
  //   window.onerror —— 在錯誤處理路徑裡二次拋錯會蓋掉原始錯誤，甚至讓
  //   錯誤邊界自己崩掉。故此處先安全轉換。
  let err: Error;
  try {
    err = error instanceof Error ? error : new Error(String(error));
  } catch {
    err = new Error('unstringifiable error');
  }

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(`[reportError]${context ? ` ${context}` : ''}`, err);
  }

  // 僅瀏覽器端且 CNZZ 就緒時上報，避免 SSR / SDK 未載入時拋錯
  if (typeof window === 'undefined' || !window._czc) return;

  try {
    // 事件屬性長度有限，label 截斷；path 併入便於還原現場
    const label = `${err.message} @ ${window.location.pathname}`.slice(0, 200);
    window._czc.push(['_trackEvent', ERROR_EVENT_CATEGORY, context || 'unknown', label]);
  } catch {
    /* 上報失敗不影響頁面 */
  }
}
